<template>
  <div>
    <template
      v-if="
        this.$USER_LOGIN.get().isAdmin &&
        inputCourier.adminSelectCourierType == 1 &&
        !isEdit
      ">
      <h6 class="heading-small text-muted mb-4">
        เลือกขนส่งที่ต้องการใช้บริการ
      </h6>
      <hr class="my-4" />
    </template>
    <template>
      <template v-if="!rateManagement">
        <h6
          class="heading-small text-muted mb-4"
          v-if="
            this.$USER_LOGIN.get().isSuperadmin ||
            this.$USER_LOGIN.get().isShippop
          ">
          เพิ่มขนส่งที่ต้องการใช้บริการ
        </h6>
        <h6 class="heading-small text-muted mb-4" v-else>รายละเอียดขนส่ง</h6>
      </template>
      <div class="row col-lg">
        <div
          class="col-lg"
          v-if="
            ((inputCourier.selectCourierType == 2 ||
              inputCourier.selectCourierType == 1) &&
              this.$USER_LOGIN.get().isSuperadmin) ||
            this.$USER_LOGIN.get().isShippop
          ">
          <div class="form-group">
            <label><span class="text-danger">*</span> รหัสขนส่ง</label>
            <input
              type="text"
              v-model="inputCourier.courierKey"
              class="form-control"
              :class="{
                'is-invalid':
                  validateData.checkInput.courierKey === false ||
                  (validateData.submitted && $v.inputCourier.courierKey.$error),
              }"
              :disabled="false"
              placeholder
              @change="$emit('checkCourierKeys', true)"
              @input="
                inputCourier.courierKey = $event.target.value.toUpperCase()
              " />
            <div
              v-if="
                validateData.submitted &&
                $v.inputCourier.courierKey.required == false &&
                !validateData.checkInput.courierKey
              "
              class="invalid-feedback d-block">
              กรุณากรอกรหัสขนส่ง
            </div>
            <div
              v-if="validateData.checkInput.courierKey === false"
              class="invalid-feedback d-block">
              กรุณากรอกรหัสขนส่งให้ถูกต้อง
            </div>
          </div>
        </div>
        <div class="col-lg">
          <label><span class="text-danger">*</span> ชื่อขนส่ง</label>
          <b-form-group>
            <b-form-input
              type="text"
              v-model="inputCourier.courierName"
              :disabled="
                (this.$USER_LOGIN.get().isAdmin && !permission.isGen) ||
                rateManagement
              "
              :class="{
                'is-invalid':
                  validateData.submitted && $v.inputCourier.courierName.$error,
              }"></b-form-input>
            <div
              v-if="
                validateData.submitted &&
                $v.inputCourier.courierName.required == false
              "
              class="invalid-feedback d-block">
              กรุณากรอกชื่อขนส่ง
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row col-lg">
        <div class="col-lg">
          <label>รหัสเรทราคา</label>
          <b-input-group>
            <b-form-input
              v-model="inputCourier.rateCode"
              ref="rateCode"
              :readonly="rateManagement || isEdit || !isEdit"></b-form-input>
            <b-input-group-append v-if="!rateManagement">
              <b-button
                variant="info"
                @click="copyRateCode()"
                :disabled="!isEdit"
                >Copy</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="col-lg">
          <label><span class="text-danger">*</span> ชื่อปุ่ม</label>
          <b-form-group description="ชื่อนี้จะแสดงในหน้า POS">
            <b-form-input
              type="text"
              v-model="inputCourier.btnTitle"
              :class="{
                'is-invalid':
                  validateData.submitted && $v.inputCourier.btnTitle.$error,
              }"
              :disabled="
                (this.$USER_LOGIN.get().isAdmin && !permission.isGen) ||
                rateManagement
              "></b-form-input>
            <div
              v-if="
                validateData.submitted &&
                $v.inputCourier.btnTitle.required == false
              "
              class="invalid-feedback d-block">
              กรุณากรอกชื่อปุ่ม
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row col-lg" v-if="inputCourier.refCode">
        <div class="col-lg" v-if="inputCourier.refCode">
          <label>รหัสโปรโมชั่น</label>
          <b-form-group>
            <b-form-input
              ref="lists"
              type="text"
              v-model="inputCourier.refCode"
              readonly></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="row col-lg">
        <div class="col-lg-12">
          <div class="form-group">
            <label><span class="text-danger">*</span> รายละเอียดขนส่ง</label>
            <input
              type="text"
              class="form-control"
              v-model="inputCourier.descriptionCouier"
              placeholder="รายละเอียดขนส่ง"
              :class="{
                'is-invalid':
                  validateData.submitted &&
                  $v.inputCourier.descriptionCouier.$error,
              }"
              :disabled="
                (this.$USER_LOGIN.get().isAdmin && !permission.isGen) ||
                rateManagement
              " />
            <div
              v-if="
                validateData.submitted &&
                $v.inputCourier.descriptionCouier.required == false
              "
              class="invalid-feedback d-block">
              กรุณากรอกรายละเอียดขนส่ง
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  props: {
    inputCourier: Object,
    validateData: Object,
    permission: Object,
    isEdit: Boolean,
    rateManagement: Boolean,
  },
  data() {
    return {
      courierList: [],
    };
  },
  validations() {
    return {
      inputCourier: {
        btnTitle: this.ruleValidate.btnTitle,
        descriptionCouier: this.ruleValidate.descriptionCouier,
        courierName: this.ruleValidate.courierName,
        courierKey: this.ruleValidate.courierKey,
        selectCourier: this.ruleValidate.selectCourier,
      },
    };
  },
  methods: {
    adminGetDefaultCouriers() {
      this.$emit("handleLoader");
      this.$http
        .get(this.$API_URL + `/shop/default/courier`, {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
        })
        .then((res) => {
          this.courierList = res.data.data;
          this.$emit("handleLoader");
        })
        .catch(() => {});
    },
    copyRateCode() {
      let rateCode = this.$refs.rateCode;
      rateCode.innerHTML = window.location.href;
      rateCode.select();
      document.execCommand("copy");
    },
  },
  computed: {
    ruleValidate() {
      let rule = {
        btnTitle: {
          required,
        },
        descriptionCouier: {
          required,
        },
        courierName: {
          required,
        },
        courierKey: {
          required,
        },
        selectCourier: {
          required,
        },
      };

      if (
        this.$USER_LOGIN.get().isSuperadmin ||
        this.$USER_LOGIN.get().isShippop
      ) {
        rule.selectCourier = {};
      }

      if (this.$USER_LOGIN.get().isAdmin) {
        if (this.inputCourier.adminSelectCourierType == 0) {
          rule.selectCourier = {};
        } else {
          rule.btnTitle = {};
          rule.descriptionCouier = {};
          rule.courierName = {};
          rule.courierKey = {};
        }
      }

      return rule;
    },
  },
};
</script>
